export const applySkipInstallmentRecalculationFlag = <T extends Record<string, unknown>>(
  payload: T,
  skip: boolean
): T => {
  if (!skip) {
    return payload;
  }
  return {
    ...payload,
    skipInstallmentRecalculation: true,
  };
};
